export const SAT_SET_MOCK_SHOP = "SAT_SET_MOCK_SHOP";
